import {
  FormControl,
  FormField,
  FormItem,
  FormMessage,
} from "@/components/ui/form";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { TSelect } from "@/types/common/select";
import CustomLabel from "./CustomLabel";

type Props = {
  form: any;
  name: string;
  placeholder: string;
  label: string;
  list: TSelect[];
  bgError?: string;
  textError?: string;
  disabled?: boolean;
};
const CustomSelect = ({
  form,
  name,
  list,
  placeholder,
  label,
  bgError,
  textError,
  disabled,
}: any) => {
  return (
    <div
      className={`grid w-full gap-1.5 ${
        disabled ? "opacity-30" : "opacity-100"
      }`}
    >
      <FormField
        control={form.control}
        name={name}
        render={({ field }) => {
          return (
            <FormItem>
              <CustomLabel id={name} label={label} />
              <Select
                onValueChange={field.onChange}
                defaultValue={field.value}
                value={field.value}
                disabled={disabled}
              >
                <FormControl>
                  <SelectTrigger
                    className={`${
                      bgError ? bgError : "aria-invalid:bg-red/10"
                    }`}
                  >
                    <SelectValue placeholder={placeholder} />
                  </SelectTrigger>
                </FormControl>
                <SelectContent>
                  {list.map((item: TSelect) => (
                    <SelectItem
                      value={item.value}
                      key={`${name}-${item.value}`}
                    >
                      {item.label}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
              <FormMessage className={`${textError ? textError : ""}`} />
            </FormItem>
          );
        }}
      />
    </div>
  );
};

export default CustomSelect;
